import Home from '@/pages/Home/index';
import { ReactElement } from 'react';

export interface IRouterItem {
  name?: string;
  path: string;
  children?: Array<IRouterItem>;
  element: ReactElement;
  meta: {};
  redirect?: string;
}
const LoadingTip = () => <div>loading....</div>;

// const Home = loadable({
//   loader: () => import('@/pages/Home/index'),
//   loading: LoadingTip,
// });

const router: IRouterItem[] = [
  {
    path: '/',
    element: <Home />,
    meta: {
      requireAuth: true,
    },
  },
];

export interface IRouterBeforeParams {
  pathname: string;
  meta: {
    title?: string;
    requireAuth?: string;
  };
}

export type TRouterBefore = (routerItem: IRouterBeforeParams) => Promise<string> | any;
/**
 * @description: global router before
 * @param {string} pathname current path
 * @param {object} meta
 * @return {string}
 */
const onRouterBefore: TRouterBefore = ({ pathname, meta }: IRouterBeforeParams) => {};

export { router, onRouterBefore };
